module.exports = __webpack_public_path__ + "img/march-3.c4591cd6.jpg";